import { render, staticRenderFns } from "./SearchField.vue?vue&type=template&id=dfba6138"
import script from "./SearchField.vue?vue&type=script&lang=js"
export * from "./SearchField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfba6138')) {
      api.createRecord('dfba6138', component.options)
    } else {
      api.reload('dfba6138', component.options)
    }
    module.hot.accept("./SearchField.vue?vue&type=template&id=dfba6138", function () {
      api.rerender('dfba6138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/CompanySwitcher/SearchField.vue"
export default component.exports